import React from 'react';
import SEO from '../../common/SEO';
import HeaderTwo from '../../common/header/HeaderTwo';
import BannerThree from '../../components/programs/SocialExperts/BannerThree';
import HomeThreeService from '../../components/programs/SocialExperts/HomeThreeService';
import AboutFive from '../../components/programs/SocialExperts/AboutFive';
import AboutTwo from '../../components/programs/SocialExperts/AboutTwo';
import TestimonialSectionTwo from '../../components/programs/SocialExperts/TestimonialSectionTwo';
import FooterTwo from '../../common/footer/FooterTwo';
import { useTranslation } from 'react-i18next';

const SocialExperts = () => {
    const { t } = useTranslation()
    return (
        <>
            <SEO title={t('seoSocialExperts')} />

            <HeaderTwo styles="header-transparent header-style-2" searchDisable buttonStyle="bg-color-white" />

            <BannerThree />

            <AboutFive />

            <AboutTwo />

            <TestimonialSectionTwo />

            <FooterTwo />
        </>
    )
}

export default SocialExperts;